'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import Box, { BoxProps } from '../../box'
import { ErrorIcon } from '../../icons'

/* -----------------------------------------------------------------------------
 * FieldErrorNotification
 * -------------------------------------------------------------------------- */

export type FieldErrorNotificationProps = BoxProps & {}

const FieldErrorNotification = (props: FieldErrorNotificationProps) => {
  return (
    <Box
      position='absolute'
      zIndex={1}
      top='50%'
      right={12}
      mt={-10 as any}
      width={20}
      height={20}
      alignItems='center'
      justifyContent='center'
      borderRadius='pill'
      bg='error'
      {...props}
    >
      <ErrorIcon fill='white' width={16} height={16} />
    </Box>
  )
}

export default FieldErrorNotification
